__turbopack_context__.v({
  "bottomClearFix": "style-module-scss-module__Ql8kTa__bottomClearFix",
  "contentWrapper": "style-module-scss-module__Ql8kTa__contentWrapper",
  "curvedContainer": "style-module-scss-module__Ql8kTa__curvedContainer",
  "curvedMask": "style-module-scss-module__Ql8kTa__curvedMask",
  "curvedText": "style-module-scss-module__Ql8kTa__curvedText",
  "curvedWrapper": "style-module-scss-module__Ql8kTa__curvedWrapper",
  "description": "style-module-scss-module__Ql8kTa__description",
  "disableLottie": "style-module-scss-module__Ql8kTa__disableLottie",
  "empty": "style-module-scss-module__Ql8kTa__empty",
  "graffitiBg": "style-module-scss-module__Ql8kTa__graffitiBg",
  "heroVideoWrapper": "style-module-scss-module__Ql8kTa__heroVideoWrapper",
  "hidden": "style-module-scss-module__Ql8kTa__hidden",
  "line": "style-module-scss-module__Ql8kTa__line",
  "lineChild": "style-module-scss-module__Ql8kTa__lineChild",
  "lineWrapper": "style-module-scss-module__Ql8kTa__lineWrapper",
  "lottieContainer": "style-module-scss-module__Ql8kTa__lottieContainer",
  "lottieContainerSpacer": "style-module-scss-module__Ql8kTa__lottieContainerSpacer",
  "lottieWrapper": "style-module-scss-module__Ql8kTa__lottieWrapper",
  "service": "style-module-scss-module__Ql8kTa__service",
  "serviceDesc": "style-module-scss-module__Ql8kTa__serviceDesc",
  "serviceItem": "style-module-scss-module__Ql8kTa__serviceItem",
  "serviceLine": "style-module-scss-module__Ql8kTa__serviceLine",
  "serviceNum": "style-module-scss-module__Ql8kTa__serviceNum",
  "serviceTitle": "style-module-scss-module__Ql8kTa__serviceTitle",
  "title": "style-module-scss-module__Ql8kTa__title",
  "videoWrapper": "style-module-scss-module__Ql8kTa__videoWrapper",
  "videoWrapperLobby": "style-module-scss-module__Ql8kTa__videoWrapperLobby",
  "wrapper": "style-module-scss-module__Ql8kTa__wrapper",
});
